import {FC} from "react";
import {Column} from "../atoms/Layout.tsx";
import Button from "../atoms/Button.tsx";
import {AUTH0_CLIENT} from "../helpers/auth0.ts";
import LogoWithTitle from "../molecules/LogoWithTitle.tsx";
import {login} from "../api/user.ts";
import {useNavigate} from "react-router";

const IndexPage: FC = () => {
    const navigate = useNavigate()

    const onClickSignIn = async () => {
        await AUTH0_CLIENT.loginWithPopup({
            authorizationParams: {
                redirect_uri: window.location.origin + "/login",
            }
        });
        const token = await AUTH0_CLIENT.getTokenSilently({
            authorizationParams: {
                redirect_uri: window.location.origin + "/login",
            },
            detailedResponse: true,
        });
        await login(token.id_token);
        navigate("/u/dashboard")
    }

    return <Column padding="20" gap="80" centerVertically centerHorizontally grow>
        <LogoWithTitle />
        <Button
            size="large"
            variant="primary"
            onClick={onClickSignIn}
        >
            Sign In
        </Button>

    </Column>
}

export default IndexPage;